export default __webpack_public_path__ + "static/media/money-banner.d9c1f996.svg";